export function ProgressModal({ visible, progress }: { visible: boolean, progress: string }) {
    if (!visible) return null;
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white p-6 rounded shadow-lg flex flex-col items-center">
          <div className="loader mb-4"></div>
          <p className="text-center text-lg font-medium">{progress}</p>
        </div>
      </div>
    );
  }
  